export enum ApiErrorCode {
  SELF_INTERSECTING_POLYGON = 'SELF_INTERSECTING_POLYGON',
  PROPERTY_DESIGNATION_NOT_FOUND = 'PROPERTY_DESIGNATION_NOT_FOUND',
  FEATURE_NOT_AVAILABLE = 'FEATURE_NOT_AVAILABLE',
  ORGANIZATION_SELECTION_REQUIRED = 'ORGANIZATION_SELECTION_REQUIRED',
}
